<template>
  <div class="core-container">
    <div class="scroll-wrapper" ref="scroll">
      <div class="scroll-content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>


<script>
import BScroll from "@better-scroll/core";

export default {
  data() {
    return {
     bs:null
    };
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    this.bs.destroy();
  },
  methods: {
    init() {
      this.bs = new BScroll(this.$refs.scroll, {
        probeType: 3,
        click: true
      });
      this.bs.on("scrollStart", () => {
        console.log("scrollStart-");
      });
      this.bs.on("scrollEnd", pos => {
        
        if (this.bs.y <= (this.bs.maxScrollY + 50)) {
              setTimeout(() => {
                this.$emit('scrollToEnd')
              },500)
              console.log('scrollEnd');
            }

      });
    },
    clickHandler(item) {
      window.alert(item);
    },
    refresh() {
        // 代理better-scroll的refresh方法
        this.bs && this.bs.refresh()
      },
  }
};
</script>



<style lang="scss"  scoped>
.core-container {
  .scroll-wrapper {
    height: 100vh;
    position: relative;
    overflow: hidden;
    .scroll-item {
      // height: 50px;
      // line-height: 50px;
      // font-size: 24px;
      // font-weight: bold;
      // border-bottom: 1px solid #eee;
      // text-align: center;

      &:nth-child(2n) {
        background-color: #f3f5f7;
      }
      &:nth-child(2n + 1) {
        background-color: #42b983;
      }
    }
  }
}
</style>